import { LogLevel } from "@azure/msal-browser";

const getAzureRedirectUri = () => {
  const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI?.trim();
  if (redirectUri) return redirectUri;
  return typeof window !== "undefined" ? window.location.origin : "";
};

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: getAzureRedirectUri(),
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) console.log(message);
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};
